import { render, staticRenderFns } from "./stepDetail.vue?vue&type=template&id=2f983869&"
import script from "./stepDetail.vue?vue&type=script&lang=js&"
export * from "./stepDetail.vue?vue&type=script&lang=js&"
import style0 from "./stepDetail.vue?vue&type=style&index=0&id=2f983869&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports